import React from 'react'
import store from '../../../redux/store'
import CancelBookingModal from '../components/list/cancel-booking-modal/cancel-booking-modal'
import { UNSAFE_renderElement as renderElement } from '@/hooks/useGlobalPortal'

const openCancelBookingModal = ({ id, onConfirm, onAbort }) => {
  const getComponent = (close) => {
    return (
      <CancelBookingModal
        open
        id={id}
        store={store}
        onSubmit={() => {
          close()
          onConfirm && onConfirm()
        }}
        onAbort={() => {
          close()
          onAbort && onAbort()
        }} />
    )
  }

  renderElement(getComponent)
}

export default openCancelBookingModal
